import { DefinitionTemplate } from '@/src/Events/components/hooks/useCreateEvent';
import { Input } from '@/src/tailwindui/input';
import { Button } from '@/src/tailwindui/button';
import { Fieldset, Label } from '@/src/tailwindui/fieldset';
export default function CreateEventStepOne({
    onNext,
    eventName,
    setEventName,
    experience,
    processingFlowTemplate,
}: {
    onNext: () => void;
    recordValues: (
        values: Record<
            string,
            string | Date | boolean | DefinitionTemplate | null | number
        >,
    ) => void;
    eventName: string;
    setEventName: (eventName: string) => void;
    platform: 'romr' | 'clickerbooth' | null;
    experience: DefinitionTemplate | null;
    setExperience: (experience: DefinitionTemplate | null) => void;
    experienceTemplates: DefinitionTemplate[];
    processingFlowTemplate: DefinitionTemplate | null;
    setProcessingFlowTemplate: (
        processingFlowTemplate: DefinitionTemplate | null,
    ) => void;
    processingFlowTemplates: DefinitionTemplate[];
    templateValues: Record<string, any>;
    setTemplateValues: (templateValues: Record<string, any>) => void;
}) {
    return (
        <>
            <section className="grid gap-x-8 gap-y-6 ">
                <div>
                    <Fieldset>
                        <Label className="plex-sans-bold text-xl">
                            What is your event's name?
                        </Label>
                        <Input
                            aria-label="Event Name"
                            name="event-name"
                            type="text"
                            value={eventName}
                            onChange={(e) => setEventName(e.target.value)}
                            className="monospace-font text-[#000000] dark:text-[#ffffff]"
                        />
                    </Fieldset>
                </div>
            </section>

            {experience || processingFlowTemplate ? (
                <div className="flex justify-center items-center  w-full gap-4 select-none">
                    {/* @ts-ignore */}
                    <Button
                        className="mt-4 dark-button w-full text-xl  disabled:opacity-50 select-none"
                        onClick={() => {
                            onNext();
                        }}
                    >
                        Continue
                    </Button>
                </div>
            ) : null}
        </>
    );
}
